import { useLocale } from "../contexts/LocaleContext";

export function MissionPage() {
  const { t } = useLocale();

  return (
    <section className="wrapper mission">
      <div className="row">
        <div className="col-full centered">
          <h1>{t("mission.title")}</h1>
          <h2>{t("mission.subtitle")}</h2>
          <p>{t("mission.goal")}</p>

          <h3>{t("mission.contributionTitle")}</h3>
          <p>{t("mission.contribution")}</p>

          <h3>{t("mission.whyTitle")}</h3>
          <p>{t("mission.why")}</p>

          <h3>{t("mission.positiveTitle")}</h3>
          <p>{t("mission.positive")}</p>

          <h3>
            {t("mission.motto")}
          </h3>
        </div>
      </div>
    </section>
  );
}
